import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Lukáš O.",
    initials: "LO",
    color: "from-blue-500 to-indigo-600",
    text: "Transakcia prebehla úspešne. Odporúčam, rýchla odozva, výborná komunikácia, spoľahlivosť a spokojnosť 😉",
  },
  {
    name: "Martin S.",
    initials: "MS",
    color: "from-emerald-500 to-teal-600",
    text: "Transakce proběhla úspěšně. Doporučuji. Rychlost dodání a okamžitá komunikace. Nejlepší prodejce na kterého jsem za poslední dobu narazil. Výborně instruktážní návody. Vřele doporučuji.",
  },
  {
    name: "Helena S.",
    initials: "HS",
    color: "from-rose-500 to-pink-600",
    text: "Vše co je v nabídce funguje bez nejmenšího problému. Doporučuji.",
  },
];

export default function ReviewsSection({ compact = false }) {
  return (
    <section
      className={`${compact ? "py-12" : "py-16"} bg-gradient-to-b from-amber-50/40 via-white to-white border-y border-amber-100/60`}
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header — souhrnné hodnocení 5/5 */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} className="w-6 h-6 fill-amber-400 text-amber-400" data-testid={`overall-star-${i}`}/>
              ))}
            </div>
            <div>
              <div className="flex items-baseline gap-2">
                <span className="font-display text-3xl font-bold text-zinc-900" data-testid="overall-rating">5,0</span>
                <span className="text-zinc-500 text-sm">/ 5,0</span>
              </div>
              <div className="text-xs text-zinc-500 mt-0.5">Hodnocení od zákazníků</div>
            </div>
          </div>
          <div className="text-xs uppercase tracking-widest text-amber-700 font-bold inline-flex items-center gap-2 bg-amber-100/60 px-3 py-1.5 rounded-full">
            <Quote className="w-3 h-3"/>Co o nás říkají
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              className="group relative bg-white rounded-2xl border border-zinc-200/80 p-6 hover:border-amber-200 hover:shadow-lg hover:shadow-amber-100/40 transition-all duration-300"
              data-testid={`review-card-${i}`}
            >
              <Quote className="absolute top-5 right-5 w-5 h-5 text-amber-300/70"/>
              <div className="flex items-center gap-1 mb-4">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="w-3.5 h-3.5 fill-amber-400 text-amber-400"/>
                ))}
              </div>
              <p className="text-sm leading-relaxed text-zinc-700 mb-5 min-h-[5.5rem]" data-testid={`review-text-${i}`}>
                „{r.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-zinc-100">
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${r.color} flex items-center justify-center text-white font-bold text-xs shadow-sm`}>
                  {r.initials}
                </div>
                <div>
                  <div className="font-semibold text-sm text-zinc-900" data-testid={`review-name-${i}`}>{r.name}</div>
                  <div className="text-[11px] text-zinc-500">Ověřený zákazník</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
